import enquire from 'enquire.js'
import {EMITS as SELECTCORE_EMITS } from '../index'
import {disableScroll, enableScroll} from '../../../services/Scroll'
import { getElementRef } from '../utils/getElementRef'

export class OffcanvasPlugin {
    constructor() {
        this.offcanvasEl = null
        this.ref = {}
    }

    options() {
        return {
            offcanvasCloseTemplate: `<button class="Select-close" type="button" data-offcanvas-close>zavrit</button>`,
        }
    }

    setup(inst) {
        this.inst = inst
        this.inst.on(SELECTCORE_EMITS.OPEN, this.handleOpen)
        this.inst.on(SELECTCORE_EMITS.CLOSE, this.handleClose)
    }

    destroy() {

    }

    handleOpen = () => {
        if (window.matchMedia('screen and (max-width: 50em)').matches) {
            if (!this.offcanvasEl) {
                this.inst.element.classList.add('is-offcanvas-enabled')
                this.offcanvasEl = document.createElement('div')
                document.body.appendChild(this.offcanvasEl)
                this.offcanvasEl.className = this.inst.element.className
                this.offcanvasEl.classList.add('Select--offcanvas')
                this.offcanvasEl.classList.add('is-open')
                this.offcanvasEl.tabIndex = '-1'
                this.offcanvasEl.appendChild(this.inst.ref.dropdown)
                
                this.ref.offcanvasClose = getElementRef(this.offcanvasEl, "offcanvasClose", this.inst.options)
                this.ref.offcanvasClose.addEventListener('click', () => {
                    this.inst.closeList()
                })
                disableScroll()
            }
        }
    }
    
    handleClose = () => {
        if (this.offcanvasEl) {
            this.offcanvasEl.parentElement.removeChild(this.offcanvasEl)
            this.offcanvasEl = null
            this.inst.element.classList.remove('is-offcanvas-enabled')
            this.inst.element.appendChild(this.inst.ref.dropdown)
            enableScroll()
        }
    }
}
